export default {
  data () {
    return {
      loadingExchangeRates: false
    }
  },
  methods: {
    async getCurrencyUpdates () {
      this.loadingExchangeRates = true
      await this.$store
        .dispatch('report/getCurrencyUpdates', this.payload)
        .then(() => {
          this.loadingExchangeRates = false
        })
        .catch((error) => {
          this.loadingExchangeRates = false
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {})
    }
  }
}
